// extracted by mini-css-extract-plugin
export default {"settings":"SettingsBlock_settings__jCRg0","top":"SettingsBlock_top__HU8g5","main":"SettingsBlock_main__a4QHY"};